/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';
import BaseCheckoutLayout from './base-checkout-layout';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import ErrorMessageFormatter from '../../services/error-message-formatter';
import { PAYMENT_METHOD_COMPONENT_MAPPING } from '../../constants/app-chekout';

import spreeStore from '../../store';
import pmsCss from '../styles/components/checkout-steps/payment/payment-method-selector.scss';
import PaymentSelectionService from '../../services/payment-selection-service';
import Address from '../order/address';
import ZoneService from '../../services/zone-service';
import Shipment from '../order/shipment';
import { OrderErrorModal } from './modals';
import APP_ACTIONS from '../../constants/app-actions';
import ShipmentsUtils from '../../services/shipments-utils';
import translations from '../../../translations/app-translations.json';

class PaymentStep extends Component {
    constructor(props) {
        super(props);
        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        const { order } = this.props;
        const paymentOptions = (order.payment_methods ? order.payment_methods.map((method, index) => ({
            id: method.id,
            name: method.attributes.name,
            description: method.attributes.description,
            type: method.attributes.type,
            isDefault: index === 0,
            ref: React.createRef(),
        })) : []);

        this.state = {
            paymentOptionSelected: paymentOptions.length > 0 ? paymentOptions[0] : null,
            paymentOptions,
            stores: [],
        };
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        const { order } = this.props;
        if (!CheckoutStepCalculator.isStepEditable(order.checkout_steps, 'payment', order.state)) {
            this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
        }

        if (!order.id) {
            this.props.redirectToCart();
        }
    }

    componentDidMount() {
        this.props.setCurrentCheckoutStep();
        const unsubscribe = spreeStore.subscribe(() => {
            if (spreeStore.getState().stores.stores.length > 0) {
                this.setState({
                    stores: spreeStore.getState().stores.stores,
                });
                unsubscribe();
            }
        });
        PaymentSelectionService.selectedPaymentMethod$.next(this.state.paymentOptionSelected);
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    getPaymentMethodComponentLayout(method) {
        const OptionComponent = PAYMENT_METHOD_COMPONENT_MAPPING()[method.type];
        if (OptionComponent) {
            return (
                <OptionComponent
                    method={method}
                    optionSelected={this.state.paymentOptionSelected}
                    onOptionSelected={(option) => this.paymentOptionSelected(option)}
                    ref={method.ref}
                    order={this.props.order}
                    locale={this.props.locale.currentLocale}
                />
            );
        }
        return null;
    }

    // eslint-disable-next-line class-methods-use-this
    handlePaymentFormSubmit(formData) {
        window.scrollTo(0, 0);
    }

    // eslint-disable-next-line class-methods-use-this
    formattedErrorMessages(errors) {
        const formErrors = errors['payments.Credit Card'];
        return ErrorMessageFormatter.formatFormSubmissionErrors(formErrors);
    }

    // eslint-disable-next-line class-methods-use-this
    paymentOptionSelected(option) {
        this.props.clearCreditCardData();
        option.ref.current.shouldNextBeEnabled();
        this.setState({
            paymentOptionSelected: option,
        });
        PaymentSelectionService.selectedPaymentMethod$.next(option);
    }

    getShipmentDetails() {
        const { order: thisOrder } = this.props;
        const { stores } = this.state;

        const shipments = stores && stores.length > 0 && thisOrder.shipments && thisOrder.shipments.length > 0 && thisOrder.shipments.sort(ShipmentsUtils.compareShipments);

        const storeIdsCount = ShipmentsUtils.countAmountOfStores(thisOrder.shipments);
        let lastStore;
        let cont = 0;

        const shipmentsMarkup = shipments && shipments.length > 0 && shipments.map((shipment, idx) => {
            const store = stores && stores.find((store) => store.id === shipment.attributes.store_ids[0]);
            if (store !== lastStore) {
                lastStore = store;
                cont = 0;
            } else {
                cont += 1;
            }

            return (
                <Shipment
                    key={idx}
                    store={stores && stores.find((store) => store.id === shipment.attributes.store_ids[0])}
                    shipment={shipment}
                    address={thisOrder.ship_address}
                    order={this.props.order}
                    excludeShipmentNumber
                    style={ShipmentsUtils.shipmentStylePadding(shipments, idx)}
                    hideStoreName={ShipmentsUtils.prevIsSameStore(shipments, idx)}
                    details={
                        `${translations[this.props.locale.currentLocale]['shipment.word']} ${cont + 1}`
                        + ` ${translations[this.props.locale.currentLocale]['of.word']} ${storeIdsCount[shipment.attributes.store_ids[0]]}`
                    }
                />
            );
        });
        return shipmentsMarkup;
    }

    // eslint-disable-next-line class-methods-use-this
    onHideDialogError() {
        spreeStore.dispatch({
            type: APP_ACTIONS.COMPLETE_ORDER_ERROR_HIDE_DIALOG,
        });
    }

    render() {
        const { order } = this.props;
        const paymentOptions = this.state.paymentOptions.map((option) => ({
            ...option,
            component: this.getPaymentMethodComponentLayout(option),
        }));
        const { orderError, showDialogError } = spreeStore.getState().placedOrder;

        return (
            <Layout>
                <BaseCheckoutLayout
                    hasExtraTimeCheckout={this.props.hasExtraTimeCheckout}
                    gracePeriod={this.props.gracePeriod}
                    locale={this.props.locale.currentLocale}
                    currentStep="payment"
                    checkoutSteps={order.checkout_steps || []}
                    order={this.props.order}
                >
                    {order.redsysPaymentError && (
                        <div className="alert alert-danger" role="alert" style={{ margin: 25 }}>
                            <FormattedMessage id="redsys-error" default="An error has occurred in your payment" />
                        </div>
                    )}
                    <OrderErrorModal
                        show={showDialogError}
                        onHide={this.onHideDialogError}
                        orderError={orderError}
                        order={order}
                    />
                    <div className={pmsCss.pms}>
                        <h3 className={pmsCss.pms__title}>
                            <FormattedMessage id="pay-with" defaultMessage="Pay with" />
                        </h3>
                        <hr />
                        <ul className="pms__options">
                            {paymentOptions.map(
                                (option) => (
                                    <li key={option.id} className={pmsCss.pms__option}>
                                        {option.component}
                                    </li>
                                ),
                            )}
                        </ul>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div className="confirmation-form__container" style={{ width: '100%' }}>
                            <div className="row">
                                <div className="col-md-6" style={{ marginBottom: '15px' }}>
                                    <h4 style={{ marginBottom: '10px' }}>
                                        <FormattedMessage id="billingAddress" defaultMessage="Billing Address" />
                                        :
                                    </h4>
                                    {this.props.order.bill_address && (
                                        <Address address={this.props.order.bill_address} />
                                    )}
                                </div>
                                {!ZoneService.isDonationZone() && (
                                    <div className="col-md-6">
                                        <h4 style={{ marginBottom: '10px' }}>
                                            <FormattedMessage id="shippingAddress" defaultMessage="Shipping Address" />
                                            :
                                        </h4>
                                        {this.props.order.ship_address && (
                                            <Address address={this.props.order.ship_address} />
                                        )}
                                    </div>
                                )}
                            </div>
                            <hr />
                            <div>
                                {this.getShipmentDetails()}
                            </div>
                        </div>
                    </div>
                </BaseCheckoutLayout>
            </Layout>
        );
    }
}

export default injectIntl(PaymentStep);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment-step.jsx
 **/